// extracted by mini-css-extract-plugin
module.exports = {"drop":"InvoiceForm_drop__3A-At","accept":"InvoiceForm_accept__1YLHB"};